// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export enum QuickTableComparingType {
    String = 0,
    Int = 1,
    Double = 2,
    Long = 3,
    DateTime = 4
}
